import React from 'react';
import { number } from 'prop-types';
import classNames from 'classnames';
import css from './Step.less';

function Step({ step = 1 }) {
  const stepClassName = num =>
    classNames([css.stepItem], {
      [css.active]: step >= num,
      [css.activeLine]: step > num,
    });
  return (
    <div className={css.step}>
      <div className={css.stepWrap}>
        <div className={stepClassName(1)}>
          <h4>Patient Details</h4>
        </div>
        <div className={stepClassName(2)}>
          <h4>Memo Content</h4>
        </div>
        <div className={stepClassName(3)}>
          <h4>Referral From - To</h4>
        </div>
      </div>
    </div>
  );
}

Step.propTypes = {
  step: number.isRequired,
};

export default Step;
